import React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from "redux";

import commonStyle from 'commonStyle';

import MODAL_KEYS from 'components/Modals/keys';


import StarredCell from './'

import {
    GET_OBJECT_SUCCESS,
    STAR_OBJECT,
    STAR_OBJECT_FAILURE,
    STAR_OBJECT_SUCCESS,
    UNSTAR_OBJECT_SUCCESS,
    UNSTAR_OBJECT,
    UNSTAR_OBJECT_FAILURE
} from 'constants/ActionTypes'

import { getObject, starObject, unstarObject, showModal } from "api/actions";

const mapStateToProps = (state, ownProps) => {
    const value = {
        fetchObject: false
    }

    const { selections = new Set([]) } = state;

    if (state.id === ownProps.id) {
        switch(state.type) {
            case GET_OBJECT_SUCCESS:
                value.loading = false;
                break;
            case STAR_OBJECT:
                value.loading = true;
                break;
            case STAR_OBJECT_SUCCESS:
                value.fetchObject = true;
                value.success = true;
                break;
            case STAR_OBJECT_FAILURE:
                value.fail = true;
                value.loading = false;
                break;
            case UNSTAR_OBJECT:
                value.loading = true;
                break;
            case UNSTAR_OBJECT_SUCCESS:
                value.fetchObject = true;
                value.success = true;
                break;
            case UNSTAR_OBJECT_FAILURE:
                value.fail = true;
                value.loading = false;
                break;
        }
    }

    if (selections.has(ownProps.id)) {
        value.isSelected = true;
    } else {
        value.isSelected = false;
    }

    return Object.assign({}, ownProps, value);
};

function useStarredCellController(props) {
    const {
        fetchObject,
        getObject,
        id,
        isDir,
        isStarred,
        loading,
        name,
        isSelected,
        textClassName,
        ...rest
    } = props;

    if (fetchObject) {
        getObject({ id })
    }

    return (
        <StarredCell
            isDir={isDir}
            isStarred={isStarred}
            loading={loading}
            name={name}
            onEdit={e => {
                e.stopPropagation();
                props.showModal({
                    modalKey: MODAL_KEYS.RENAME_OBJECT,
                    modalId: id,
                    modalInfo: { name }
                })
            }}
            onStar={e => {
                e.stopPropagation();
                if (!isStarred) {
                    props.starObject({ id: props.id });
                } else {
                    props.unstarObject({ id: props.id });
                }
            }}
            isSelected={isSelected}
            selectedBackgroundColor={commonStyle.dimPrimary(0.1)}
            textClassName={textClassName}
            {...rest}
        />
    )
}

const dispatchToProps = (dispatch) => {
    return bindActionCreators({ getObject, starObject, unstarObject, showModal }, dispatch)
};

export default connect(mapStateToProps, dispatchToProps)(useStarredCellController);